export default __webpack_public_path__ + "static/media/ic_thick_plus.466e425c.svg";